export default "__VITE_ASSET__wqmo$Vtx__"